var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWaterBed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 30 30"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  clipPath: "url(#water_bed_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.1 20.772a4.5 4.5 0 0 0 1.806-.165 4.2 4.2 0 0 0 1.554-.857c.318.322.707.579 1.14.755.435.176.905.267 1.38.267s.944-.091 1.378-.267a3.4 3.4 0 0 0 1.142-.755c.318.322.707.579 1.14.755.435.176.905.267 1.38.267s.944-.091 1.378-.267a3.4 3.4 0 0 0 1.142-.755c.44.388.972.68 1.553.857a4.5 4.5 0 0 0 1.807.165"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.375 4.656H6.625c-.725 0-1.312.588-1.312 1.313V23.03c0 .725.587 1.313 1.312 1.313h15.75c.725 0 1.313-.588 1.313-1.313V5.97c0-.725-.588-1.313-1.313-1.313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.875 7.281H9.25c-.725 0-1.312.588-1.312 1.313v1.312c0 .725.587 1.313 1.312 1.313h2.625c.725 0 1.313-.588 1.313-1.313V8.594c0-.725-.588-1.313-1.313-1.313M19.75 7.281h-2.625c-.725 0-1.312.588-1.312 1.313v1.312c0 .725.587 1.313 1.312 1.313h2.625c.725 0 1.313-.588 1.313-1.313V8.594c0-.725-.588-1.313-1.313-1.313M5.313 11.219h18.375M5.313 15.156h18.375"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "water_bed_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4 4h21v21H4z"
})))));
export default SvgWaterBed;